export default {
  process: {
    step1: '拼图设置',
    step2: '玩法设置',
    next: '下一步',
    previous: '上一步',
    finish: '完成',
  },
  step1: {
    setting1: {
      title: '底图',
      upload: '请上传底图',
    },
    setting2: {
      title: '拼图块',
      blockNum: '块数',
      style: '拼图样式选择',
      edgeStyle: '接缝样式选择',
    },
    setting3: {
      title: '高级设置',
      border: '描边',
      innerShadow: '内阴影',
      relief: '浮雕',
      solidLine: '实线',
      dashLine: '虚线',
      lineWidth: '粗细',
      solidSegment: '虚线',
      blankSegment: '间距',
      blur: '模糊',
      topShadow: '高光颜色',
      bottomShadow: '暗面颜色',
    },
  },
  step2: {
    title: '特定玩法拼图块',
    titleTip: '选中特殊玩法拼图块，然后在画布里选择拼图块赋予对应特殊逻辑。',
    addSpePuzzle: '添加特定玩法拼图块',
    preview: '预览样式',
    closePreview: '关闭预览',
    name: '名称',
    placeholder: '请输入',
    nameEmptyWarning: '名称不能为空',
    puzzleColor: '拼图颜色',
    lightBorder: '发光描边',
    lightInnerShadow: '发光内阴影',
    blur: '模糊',
  },
}
